import { get as lodashGet } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectProducts = (state: object) => lodashGet(state, 'products', emptyArray);

export const selectIsLoading = (state: object) => lodashGet(state, 'isLoading', false);

export const selectHasLoaded = (state: object) => lodashGet(state, 'hasLoaded', false);

export const selectError = (state: object) => lodashGet(state, 'error', null);
